import {
  bulkDeleteFileEntries,
  listFileEntries,
  retrieveFileEntryModel,
} from '@app/gen/files';
import {ListFileEntriesParams} from '@app/gen/schemas/list-file-entries-params';
import {apiClient, queryClient} from '@common/http/query-client';
import {mutationOptions, queryOptions} from '@tanstack/react-query';
import {FirstParam} from '@ui/utils/ts/extract-params';

export const fileEntriesBaseKey = ['file-entries'];

export const listFileEntriesOptions = (params: ListFileEntriesParams) =>
  queryOptions({
    queryKey: [...fileEntriesBaseKey, params],
    queryFn: () => listFileEntries(params),
    throwOnError: false,
  });

export const retrieveFileEntryModelOptions = (entryId: number) =>
  queryOptions({
    queryKey: [...fileEntriesBaseKey, entryId, 'model'],
    queryFn: () => retrieveFileEntryModel(entryId),
  });

export const deleteFileEntriesOptions = mutationOptions({
  mutationFn: (params: FirstParam<typeof bulkDeleteFileEntries>) =>
    bulkDeleteFileEntries(params),
  onSuccess: () => {
    queryClient.invalidateQueries({
      queryKey: fileEntriesBaseKey,
    });
  },
});

export const bulkUpdateFolderColor = (payload: {
  entryIds?: number[];
  icon_color?: string | null;
  reset_all?: boolean;
}) =>
  apiClient
    .post<{status?: string; count?: number}>('file-entries/bulk-icon-color', payload)
    .then(r => r.data);

export const exportFileEntriesCsv = (ids?: number[]) =>
  apiClient
    .post<{result: string; downloadPath: string | null}>(
      'file-entries/csv/export',
      ids?.length ? {ids: ids.join(',')} : undefined,
    )
    .then(r => r.data);

export const exportFileEntriesCsvOptions = () =>
  mutationOptions({
    mutationFn: exportFileEntriesCsv,
  });

export const bulkUpdateFolderColorOptions = mutationOptions({
  mutationFn: bulkUpdateFolderColor,
  onSuccess: () => {
    queryClient.invalidateQueries({
      queryKey: fileEntriesBaseKey,
    });
    queryClient.invalidateQueries({queryKey: ['drive']});
  },
});
